import { faArrowUpFromSquare } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PureComponent } from 'react';

import './ShareIcon.style';

/** @namespace Elganso/Component/ShareIcon/Component */
export class ShareIconComponent extends PureComponent {
    __construct(props) {
        super.__construct(props);
        this.shareProduct = this.shareProduct.bind(this);
    }

    shareProduct() {
        const { product, metaLink } = this.props;

        if (window.navigator.share) {
            window.navigator.share({
                title: product.name,
                text: product.name,
                url: metaLink
            }).then(
                /** @namespace Elganso/Component/ShareIcon/Component/ShareIconComponent/shareProduct/then/catch/share/then */
                // eslint-disable-next-line no-console
                () => console.log('Successful share')
            ).catch(
                /** @namespace Elganso/Component/ShareIcon/Component/ShareIconComponent/shareProduct/then/catch */
                // eslint-disable-next-line no-console
                (error) => console.log('Error sharing', error)
            );
        } else {
            alert('Tu navegador no soporta esta funcion.');
        }
    }

    render() {
        return (
            <div
              block="ShareProductButton"
              onClick={ this.shareProduct }
              onKeyDown={ this.shareProduct }
            >
                <FontAwesomeIcon icon={ faArrowUpFromSquare } />
            </div>
        );
    }
}

export default ShareIconComponent;
